import { render, staticRenderFns } from "./TitledCard.vue?vue&type=template&id=12cb3599&scoped=true"
import script from "./TitledCard.vue?vue&type=script&lang=js"
export * from "./TitledCard.vue?vue&type=script&lang=js"
import style0 from "./TitledCard.vue?vue&type=style&index=0&id=12cb3599&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cb3599",
  null
  
)

export default component.exports